
// const actions = [
//     { icon: <Printer className="w-4 h-4" />, label: "Print", isBordered: true, onClick: handlePrint },
//     { icon: <Plus className="w-4 h-4" />, label: "Add Section", onClick: handleAddSection },
//     {label: "Download", onClick: handleDownload },
//     { icon: <Trash className="w-4 h-4" />, label: "Delete", isLight: true, onClick: handleDelete },
//   ]

// add this type of array **************

import { ArrowLeft } from "lucide-react"
import { Button } from "./Button"
import { Divider } from "@mui/material"
import { useState } from "react"


export default function DynamicActionBar({
  backButtonLabel,
  onBackClick,
  actions,
  showArrowLeft
}) {
  return (
    <div style={{ position: 'sticky', top: '0', zIndex: '1', backgroundColor: '#F6F7F9' }}>
      <div className="flex items-center justify-between py-4">
        <div className="flex items-center" >
          {showArrowLeft && <ArrowLeft className="w-4 h-4 mr-2" onClick={onBackClick} />}
          <span className="commanTextClass ">{backButtonLabel}</span>
        </div>
        <div className="flex space-x-2">
          {actions?.map((action, index) => {
            if ('type' in action && action.type === 'toggle') {
              return (
                <ToggleButtonsBar
                  key={index}
                  options={action.options}
                  selectedOptions={action.selectedOptions}
                  onChange={action.onChange}
                />
              )
            } else {
              return (
                <Button
                  key={index}
                  type="button"
                  isLight={action.isLight}
                  disabled={action.disabled}
                  isBordered={action.isBordered}
                  onClick={action.onClick}
                  icon={action.icon}
                  label={action.label}
                  roundedButton={action.roundedButton}
                  extraClass={action.extraClass}
                />
              )
            }
          })}
        </div>
      </div>
      <Divider />
    </div>
  )
}

function ToggleButtonsBar({ options, selectedOptions, onChange }) {
  const handleToggle = (index) => {
    const newSelectedOptions = [...selectedOptions]
    newSelectedOptions[index] = !newSelectedOptions[index]
    onChange(newSelectedOptions)
  }

  return (
    <div className="flex space-x-2">
      {options.map((option, index) => (
        <ToggleButton
          key={index}
          label={option.label}
          selected={selectedOptions[index]}
          onClick={() => handleToggle(index)}
          color={option.color}
        />
      ))}
    </div>
  )
}


const ToggleButton = ({ label, selected, onClick, color }) => {
  const baseClasses = "px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2"
  const colorClasses = {
    orange: selected ? "bg-orange-500 text-white" : "bg-white text-orange-500 border border-orange-500",
    green: selected ? "bg-green-500 text-white" : "bg-white text-green-500 border border-green-500"
  }

  return (
    <button
      className={`${baseClasses} ${colorClasses[color]} ${selected ? 'shadow-md' : 'hover:bg-gray-50'}`}
      onClick={onClick}
    >
      {label}
    </button>
  )
}